import { createElement, useMemo } from 'react';
import Avatar from '@material-ui/core/Avatar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Skeleton from '@material-ui/lab/Skeleton';
import { LanguageLink, themeColor } from '@hilma/netina2all';

interface AssociationProps {
	associationName?: string;
	imagePath?: string;
	website?: string;
	addAssociaion?: boolean;
	loading?: boolean;
}

const Association: React.FC<AssociationProps> = ({ associationName, imagePath, website, addAssociaion = false, children, loading }) => {
	const classes = useStyles();

	const Container = useMemo<React.FC<any>>(() => ({ children, ...rest }) => {
		let element: React.FC<any> | React.ComponentClass<any> | string = 'a',
			props: object = { href: website, target: '_blank' };

		if (addAssociaion) {
			element = LanguageLink;
			props = { to: '/associations/registration' };
		} else if (loading) {
			element = Skeleton;
			props = { variant: 'rect' };
		}

		return createElement(element, { ...props, ...rest, children });
	}, [addAssociaion, loading, website]);

	return (
		<Container className={classes.container}>
			<Avatar
				className={classes.avatar}
				classes={{ root: classes.avatar, img: classes.avatarImage }}
				alt={associationName}
				src={imagePath}
				variant="rounded"
			>
				{addAssociaion ? children : associationName}
			</Avatar>

			<div className={classes.overlay}>
				<span>{associationName}</span>
			</div>
		</Container>
	);
}

export default Association;

const useStyles = makeStyles(theme => ({
	container: {
		textDecoration: 'none',
		top: 0,
		right: 0,
		width: '100%',
		boxSizing: 'border-box',
		margin: 'auto',
		alignItems: 'center',
		display: 'flex',
		position: 'relative',

		'&:hover:not(:first-child) $overlay': {
			opacity: 1
		}
	},

	avatar: {
		boxShadow: '0px 3px 6px $boxShadow',
		width: '100%',
		[theme.breakpoints.down(500)]: {
			height: '35vw'
		},
		[theme.breakpoints.up(500)]: {
			height: 140
		},
		[theme.breakpoints.up(1600)]: {
			height: 211
		}
	},

	avatarImage: {
		objectFit: 'contain',

		[theme.breakpoints.down(500)]: {
			padding: '2vw'
		},
		[theme.breakpoints.up(500)]: {
			padding: 8
		},
		[theme.breakpoints.up(1600)]: {
			padding: 12
		},
	},

	overlay: {
		top: 0,
		right: 0,
		position: 'absolute',
		width: '100%',
		boxSizing: 'border-box',
		margin: 'auto',
		alignItems: 'center',
		display: 'flex',
		padding: '10px',
		fontSize: '1.1rem',
		justifyContent: 'center',
		opacity: 0,
		pointerEvents: 'none',
		transition: 'opacity 0.2s linear',
		height: '100%',
		background: `${themeColor}c2`,
		color: '#fff',
		borderRadius: '5px',
		textAlign: 'center',
		wordBreak: 'break-word',
	}
}));